import { useDispatch } from "react-redux";
import CgFormCreator from "../../common/CgFormCreator";
import "./ContactUs.scss";
import { useNavigate } from "react-router-dom";
import { addContactUsData } from "../../store/dashboard/ContactUsReducer";
import React, { useState } from "react";


const issuesDropdownOptions = [
    { id: 0, value: "Brighter Schedule", metadata: "brighter_schedule" },
    { id: 1, value: "Brighter Score", metadata: "brighter_score" },
    { id: 2, value: "Online Reviews", metadata: "online_reviews" },
    { id: 3, value: "Incorrect Data", metadata: "incorrect_data" },
    { id: 4, value: "General Inquiries", metadata: "general_inquiries" },
    { id: 5, value: "Technical Issues", metadata: "technical_issues" },
    { id: 6, value: "Appointment Issue", metadata: "appointment_issue" },
    { id: 7, value: "Other", metadata: "other" },
]

const ContactUs = () => {

    const [validatedValues, setValidatedValues] = useState({
        contactName: "",
        phoneNumber: "",
        issue: ""
    })


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const contactUsSchema = [
        {
            component: "input",
            label: "Contact Name",
            type: "text",
            name: "contactName",
            placeholder: " ",
            required: true,
            className: validatedValues?.contactName?.length === 0 ? "errorBorder" : "contactNameField",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
        },
        {
            component: "input",
            label: "PHONE",
            type: "text",
            name: "phoneNumber",
            required: true,
            minLength: 10,
            placeholder: "XXX-XXX-XXXX",
            className: validatedValues?.phoneNumber?.length !== 10 ? "errorBorder" : "phoneNumberField",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
        },
        {
            component: "dropdown",
            label: "What is your message about ?",
            name: "issue",
            dropdownOptions: issuesDropdownOptions,
            onSelectCallBack: (name, value, selectedItem) => { setValidatedValues({ ...validatedValues, [name]: selectedItem?.metadata }) },
            className: validatedValues?.issue?.length === 0 ? "errorBorder" : "issueField",
            required: true,
        },
        {
            component: "textarea",
            name: "note",
            label: "Comments",
            placeholder: "Comments",
            cols: 83,
            rows: 5,
            needBorder: true,
            className: "commentsField",
            onChangeCallback: () => { },
        },
    ]
    const handleGoBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/dashboard");
        }
    };

    const handleDisablePrimaryButton = () => {
        if (validatedValues?.contactName?.length === 0 || validatedValues?.phoneNumber?.length !== 10 || validatedValues?.issue?.length === 0) {
            return false;
        }
        return true;
    }


    const handleContactUsForm = (formData) => {
        const payload = {
            ...formData,
            issue: validatedValues?.issue
        }
        dispatch(addContactUsData(payload));
    }


    const RenderAddContactUsForm = () => {
        return (
            <div className="container-fluid contactUsContainer">
                <div className="row">
                    <div className="col-md-3">
                        <div className="leftSideSection">
                            <div className="goBackBtn" onClick={() => handleGoBack()}><i className="bi bi-chevron-left"></i> Go back</div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="contactUsSection">
                            <h2>Contact Us</h2>
                            <p>For questions or concerns, please contact us using one of the following methods:</p>
                            <h5>Complete the contact form</h5>
                            <CgFormCreator
                                onSubmitCallback={(formData) => {
                                    handleContactUsForm(formData)
                                }}
                                noCancel
                                primaryButton="Submit"
                                formClassName="contactUsForm"
                                schema={contactUsSchema}
                                enablePrimaryBtn={handleDisablePrimaryButton()}
                            />
                            <h5>Contact us by phone</h5>
                            <p>424-316-2534</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    return (
        RenderAddContactUsForm()
    )
}
export default ContactUs;